import script from "./WidgetContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetContainer.vue?vue&type=script&setup=true&lang=js"

import "./WidgetContainer.vue?vue&type=style&index=0&id=2657df65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2657df65"]])

export default __exports__